module.exports = __webpack_public_path__ + "img/TjaKeinStrand.aaea9e71.svg";